if (typeof global.navigator === "undefined") {
	// @ts-expect-error
	global.navigator = {};
}
const userAgent: string | undefined = global.navigator.userAgent;

export default userAgent;
